<template>
  <div id="page">
    <div align="center" style="margin-top: 48px">
      <div>
        <img
          src="static/hsbank/img_order_result.png"
          width="96px"
          height="72px"
        />
      </div>
      <div style="margin-top: 8px">
        <label>上传图片正在审核中</label>
      </div>
      <div style="margin-top: 8px">
        <label>我们将在24小时内完成审核</label>
      </div>
      <div style="margin-top: 8px">
        <label>此期间请不要申请新的卡片</label>
      </div>
      <div style="margin-top: 8px">
        <label>否则将有可能导致此次申请开卡失败</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderResult_hs",
  data() {
    return {
      orderNo: "",
    };
  },
  beforeRouteLeave(to, from, next) {
    console.log("beforeRouteLeave");
    console.log("to", to);
    console.log("from", from);
    next();
  },
  mounted: function () {
    this.orderNo = this.$route.params.orderNo;
    console.log("orderNo:" + this.orderNo);
    let count = this.$store.state.hs.reuploadCount;
    console.log("reuploadCount:" + count);
    let entrance = sessionStorage.getItem("entrance");
    console.log("entrance:" + entrance);
    let storeStr = JSON.stringify(this.$store.state.hs);
    console.log(storeStr);
  },
  destroyed: function () {
    this.toHomeHs();
  },
  methods: {
    toHomeHs: function () {
      let entrance = sessionStorage.getItem("entrance");
      let count = this.$store.state.hs.reuploadCount;
      let isReupload = count > 0;
      if (entrance == 1) {
        // 申请卡面入口
        if (isReupload) {
          let backCount = count * 2 - 1 + 3;
          console.log("backCount:" + backCount);
          this.$router.go(-backCount);
        } else {
          this.$router.go(-2);
        }
      } else if (entrance == 2) {
        // 查询进度入口
        if (isReupload) {
          let backCount = count * 2 - 1 + 2;
          console.log("backCount:" + backCount);
          this.$router.go(-backCount);
        } else {
          this.$router.go(-1);
        }
      } else {
      }
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/huishangbank/OrderResult_hs.vue